export const filterUsersBySearch = (users, searchTerm) => {
  const term = searchTerm.toLowerCase();
  return users.filter(
    (user) =>
      user.name.toLowerCase().includes(term) ||
      user.mobile.includes(term)
  );
};

export const getInitial = (name) =>
  name?.charAt(0)?.toUpperCase() || "?";

export const getInitials = (name) =>
  name?.charAt(0)?.toUpperCase() || "?";

export const getAvatarColor = (name) => {
  const colors = [
    "#FF6B6B", "#4ECDC4", "#45B7D1", "#96CEB4", "#FFEAA7",
    "#DDA0DD", "#98D8C8", "#F7DC6F", "#BB8FCE", "#85C1E9"
  ];
  const index = name ? name.length % colors.length : 0;
  return colors[index];
};
